import React from 'react';
import { cn } from '@/lib/utils';

interface DetailRowProps {
  label: string;
  children: React.ReactNode;
  className?: string;
}

/** A read-only value, with its term in a fixed left column so values line up. */
const DetailRow: React.FC<DetailRowProps> = ({ label, children, className }) => (
  <div
    className={cn(
      'flex min-h-[52px] flex-col gap-1 px-4 py-2.5',
      '@lg/section:flex-row @lg/section:items-center @lg/section:gap-6',
      className,
    )}
  >
    <dt className="revy-cjk shrink-0 text-xs leading-[1.5] tracking-[0.02em] text-muted-foreground @lg/section:w-40">
      {label}
    </dt>
    <dd className="revy-cjk min-w-0 text-sm leading-[1.5]">{children}</dd>
  </div>
);

export default DetailRow;
